import * as React from "react";
import styled, { css } from "../../../styled/index";

export const Table = styled("table")`
  width: 100%;
  border-collapse: collapse;
  th, td {
    padding: 7px 5px;
    &:first-child {
      padding-left: 0
    }
    &:last-child {
      padding-right: 0
    }
  }
`;

// HEAD

export const TableHead = styled("thead")`
   
`;

export const TableHeadRow = styled("tr")`
  border-bottom: 1px solid ${({theme}) => theme.box.border};
`;

export const TableHeadCell = styled("th")`
  font-size: ${({theme}) => theme.font.size}px;
  font-weight: 600;
  text-align: left;
  &:last-child {
    text-align: right;
  }
`;

// BODY

export const TableBody = styled("tbody")`

`;

export const TableRow = styled("tr")`
  border-bottom: 1px dashed ${({theme}) => theme.box.border};
  &:last-child {
    border-bottom: 1px solid ${({theme}) => theme.box.border};
  }
`;

export const TableCell = styled("td")`
  font-size: ${({theme}) => theme.font.size}px;
  text-align: left;
  line-height: 1.4;
  &.small, .small {
    font-size: ${({theme}) => theme.font.size - 2}px;
  }
  &.smaller, .smaller {
    font-size: ${({theme}) => theme.font.size > 14 ? theme.font.size - 2 : theme.font.size - 1}px;
  }
  &:last-child {
    text-align: right;
  }
  span, p { line-height: 1.4; }
`;
